import { useTranslation } from 'react-i18next'

import { AIButtonContainedDark } from '../../../AIButton'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import {
  QA_NAME_GRETA_AI_CHAT_FEEDBACK_CANCEL,
  QA_NAME_GRETA_AI_CHAT_FEEDBACK_SUBMIT,
} from '../GretaAIChatFeedbackForm.constants'

import * as styles from './GretaAIChatFeedbackActions.module.css'

function GretaAIChatFeedbackActions({ onCancel, onSubmit }) {
  const { t } = useTranslation()

  return (
    <div className={styles.actions}>
      <Button.Text
        isGrey
        height={BUTTON_HEIGHT_32}
        isInline={false}
        qaName={QA_NAME_GRETA_AI_CHAT_FEEDBACK_CANCEL}
        text={t('Greta.CancelKey')}
        onClick={onCancel}
      />

      <AIButtonContainedDark
        height={BUTTON_HEIGHT_32}
        qaName={QA_NAME_GRETA_AI_CHAT_FEEDBACK_SUBMIT}
        text={t('Greta.FeedbackSubmitKey')}
        onClick={onSubmit}
      />
    </div>
  )
}

export default GretaAIChatFeedbackActions
